import styled from 'styled-components';

const MOBILE_MAX = '760px';

export const Container = styled.div`
  width: 100%;
  margin: 16px 0 32px;
`;

export const Link = styled.a`
  display: block;
  width: 100%;
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;

  &.desktop-img {
    display: block;
  }

  &.mobile-img {
    display: none;
  }

  @media (max-width: ${MOBILE_MAX}) {
    &.desktop-img {
      display: none;
    }

    &.mobile-img {
      display: block;
    }
  }
`;
